module.exports = __webpack_public_path__ + "img/bg-threat-unknown.aecd08bc.png";